export { default as ModalCreateWheadSetting } from './ModalCreateWheadSetting';
export { default as ModalDeleteWheadSetting } from './ModalDeleteWheadSetting';
export { default as ModalCreateLawSettingList } from './ModalCreateLawSettingList';
export { default as ModalDeleteLawSettingList } from './ModalDeleteLawSettingList';